import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LayoutContext } from '../../contexts/layout';
import { saveMenuChange } from '../../redux/actions/menu';
import { layoutStateSelector } from '../../redux/selectors/layouts';

function Header() {
    const { layoutId } = useContext(LayoutContext);
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { title, showCloseButton } = useSelector(layoutStateSelector(layoutId));

    const onCloseClick = () => navigate(-1);

    const onMenuClick = () => {
        dispatch(saveMenuChange({
            type: 'collapse',
        }));
    };

    return (
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
            <div className="d-flex flex-grow-1 justify-content-between">
                <div className="d-flex align-items-center">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <button className="header-menu-button nav-link" data-widget="pushmenu" type="button" onClick={onMenuClick}>
                                <i className="fas fa-bars" />
                            </button>
                        </li>
                    </ul>
                    {typeof title === 'string' && <div dangerouslySetInnerHTML={{ __html: title }} />}
                </div>
                {showCloseButton && (
                    <button className="header-menu-button nav-link" type="button" onClick={onCloseClick}>
                        <i className="fas fa-close" />
                    </button>
                )}
            </div>
        </nav>
    );
}

export default Header;
